import script from "./DimensionSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./DimensionSelector.vue?vue&type=script&setup=true&lang=js"

import "./DimensionSelector.vue?vue&type=style&index=0&id=47c7caff&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47c7caff"]])

export default __exports__